import type { TourDefinition } from '../tours.types';

export const CERTIFICATE_ADD_TOUR: TourDefinition = {
  id: 'certificate_add_help',
  route: '/perfil/perfil',
  remember: true,
  steps: [
    {
      element: '[data-tour="modal-cert-title"]',
      popover: {
        title: 'Crear certificado',
        description:
          'Este formulario te ayuda a registrar un certificado para firmar documentos.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="cert-scratch-input"]',
      popover: {
        title: 'Scratchcard / Usuario',
        description:
          'Ingresa el scratchcard o usuario del certificado. Luego presiona buscar para autocompletar los datos.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="cert-scratch-search"]',
      popover: {
        title: 'Buscar',
        description:
          'El sistema consultará el servicio externo para obtener el nombre, tipo y vigencia del certificado automáticamente.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: '[data-tour="cert-fields"]',
      popover: {
        title: 'Datos del certificado',
        description:
          'Si el certificado existe, estos campos se completan automáticamente. Si hay un error del servicio, podrás completarlos manualmente.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="cert-save-btn"]',
      popover: {
        title: 'Guardar',
        description:
          'Guarda el certificado para que quede disponible en los procesos de firma.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: '[data-tour="cert-close-btn"]',
      popover: {
        title: 'Cerrar',
        description:
          'Puedes cerrar el formulario si deseas hacerlo más tarde.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
